module.exports = __webpack_public_path__ + "img/aftereffects.1a521e32.svg";